'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownMenuHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropdownMenuHeader(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'li',
    { role: 'presentation', className: 'dropdown-header' },
    children
  );
}

DropdownMenuHeader.propTypes = {
  children: _bcPropTypes.childrenShape.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-menu/components/DropdownMenuHeader.component.js
// module id = 626
// module chunks = 0 1 9 10 11